import input from './input';
import button from './button';
import app from './app';
import categories from './categories';

const german = {
    title: 'MarketPrint',
    button: button,
    input: input,
    app: app,
    categories: categories,
};

export default german;
